import AppointmentPage from "../app/admin/appointments";
import BlogSection from "../app/admin/blogs";
import CampaignPage from "../app/admin/campaign";
import ContentHub from "../app/admin/contentHub";
import AdminCatalogue from "../app/admin/catalogue";
import AdminClients from "../app/admin/clients";
import AdminCustomerSupport from "../app/admin/customorSupport";
import AdminDashboard from "../app/admin/dashboard";
import { DonationPage } from "../app/admin/donation";
import AdminFaqs from "../app/admin/faqs";
import AdminNotification from "../app/admin/notification";
import OrderPage from "../app/admin/order";
import Products from "../app/admin/products";
import AdminReports from "../app/admin/report";
import AdminSettings from "../app/admin/setting/Index";
import AdminSubscription from "../app/admin/subscription";
import AdminWithdraw from "../app/admin/withdraw";
import ForgotPassword from "../app/auth/forgot";
import Forgotverification from "../app/auth/forgot/ForgotVerification";
import Login from "../app/auth/login";
import ResetPassword from "../app/auth/resetPassword";
import { APP_ICONS } from "../assets";

const AuthRoutes = [
  {
    id: 1,
    name: "Login",
    component: <Login />,
    path: "/login",
    icon: "location_on",
  },

  {
    id: 4,
    name: "Forgot Password",
    component: <ForgotPassword />,
    path: "/forgot-password",
    icon: "location_on",
  },
  {
    id: 5,
    name: "Forgot Verify",
    component: <Forgotverification />,
    path: "/forgot-password/verify",
    icon: "location_on",
  },
  {
    id: 6,
    name: "Reset Password",
    component: <ResetPassword />,
    path: "/reset-password",
    icon: "location_on",
  },
];

const AdminRoutes = [
  {
    id: 1,
    name: "dashboard",
    component: <AdminDashboard />,
    path: "/",
    icon: APP_ICONS.dashboardBlackIcon,
    iconActive: APP_ICONS.dashboardWhiteIcon,
  },
  {
    id: 2,
    name: "clients",
    component: <AdminClients />,
    path: "/clients",
    icon: APP_ICONS.smileBlackIcon,
    iconActive: APP_ICONS.smileWhiteIcon,
  },
  {
    id: 3,
    name: "catalogue",
    component: <AdminCatalogue />,
    path: "/catalogue",
    icon: APP_ICONS.bookBlackIcon,
    iconActive: APP_ICONS.bookWhiteIcon,
  },
  {
    id: 4,
    name: "products",
    component: <Products />,
    path: "/Products",
    icon: APP_ICONS.bagBlackIcon,
    iconActive: APP_ICONS.bagWhiteIcon,
  },
  {
    id: 5,
    name: "allSales",
    component: <OrderPage />,
    path: "/sale",
    icon: APP_ICONS.cartBlackIcon,
    iconActive: APP_ICONS.cartWhiteIcon,
  },
  {
    id: 6,
    name: "appointments",
    component: <AppointmentPage />,
    path: "/appointments",
    icon: APP_ICONS.calendarBlackIcon,
    iconActive: APP_ICONS.calendarWhiteIcon,
  },
  {
    id: 7,
    name: "donations",
    component: <DonationPage />,
    path: "/donations",
    icon: APP_ICONS.donationBlackIcon,
    iconActive: APP_ICONS.donationWhiteIcon,
  },
  {
    id: 8,
    name: "customerSupport",
    component: <AdminCustomerSupport />,
    path: "/customer-support",
    icon: APP_ICONS.handshakeBlackIcon,
    iconActive: APP_ICONS.handshakeWhiteIcon,
  },
  {
    id: 9,
    name: "notifications",
    component: <AdminNotification />,
    path: "/notifications",
    icon: APP_ICONS.notificationBlackIcon,
    iconActive: APP_ICONS.notificationWhiteIcon,
  },
  {
    id: 10,
    name: "reports",
    component: <AdminReports />,
    path: "/reports",
    icon: APP_ICONS.reportBlackIcon,
    iconActive: APP_ICONS.reportWhiteIcon,
  },
  {
    id: 11,
    name: "subscriptions",
    component: <AdminSubscription />,
    path: "/subscription",
    icon: APP_ICONS.packageBlackIcon,
    iconActive: APP_ICONS.packageWhiteIcon,
  },
  {
    id: 12,
    name: "withdrawRequests",
    component: <AdminWithdraw />,
    path: "/withdraw-requests",
    icon: APP_ICONS.packageBlackIcon,
    iconActive: APP_ICONS.packageWhiteIcon,
  },
  {
    id: 13,
    name: "faqs",
    component: <AdminFaqs />,
    path: "/faqs",
    icon: APP_ICONS.packageBlackIcon,
    iconActive: APP_ICONS.packageWhiteIcon,
  },
  {
    id: 14,
    name: "blogs",
    component: <BlogSection />,
    path: "/blogs",
    icon: APP_ICONS.packageBlackIcon,
    iconActive: APP_ICONS.packageWhiteIcon,
  },
  {
    id: 15,
    name: "settings",
    component: <AdminSettings />,
    path: "/settings",
    icon: APP_ICONS.settingBlackIcon,
    iconActive: APP_ICONS.settingWhiteIcon,
  },
  {
    id: 16,
    name: "contentHub",
    component: <ContentHub />,
    path: "/content-hub",
    icon: APP_ICONS.packageBlackIcon,
    iconActive: APP_ICONS.packageWhiteIcon,
  },
  {
    id: 17,
    name: "campaigns",
    component: <CampaignPage />,
    path: "/campaigns",
    icon: APP_ICONS.packageBlackIcon,
    iconActive: APP_ICONS.packageWhiteIcon,
  },
];

export { AdminRoutes, AuthRoutes };
